<p-toast />
<div class="outer-container">
  <span class="voicemailtitile">{{ title }}</span>
  <span class="close" (click)="closeVoicemailsPopup()">X</span>
  <div class="console-container">
    <div class="row vmdetails">
      <div class="col-2">
        <label>User</label>
        <label>Company</label>
        <label>Caller No.</label>
      </div>
      <div class="col-2 data">
        <label>{{ data.User || '-' }}</label>
        <label>{{ data.Company || '-' }}</label>
        <label>{{ data.UserPhoneNumber || '-' }}</label>
      </div>
      <div class="col-2">
        <label>Queue</label>
        <label>Inbound Number</label>
        <label>Request Type</label>
      </div>
      <div class="col-2 data">
        <label>{{ data.Queue || '-' }}</label>
        <label>{{ data.InboundPhoneNumber || '-' }}</label>
        <label>{{ data.RequestType || '-' }}</label>
      </div>
      <div class="col-2">
        <label>Status</label>
        <label>Reviewed</label>
        <label>Responded</label>
      </div>
      <div class="col-2 data">
        <label>{{ data.Status || '-' }}</label>
        <label *ngIf="data.Reviewed">{{ data?.Reviewed | custdate }}</label>
        <label *ngIf="!data.Reviewed">{{ '-' }}</label>
        <label *ngIf="data.Responded">{{ data.Responded | custdate }}</label>
        <label *ngIf="!data.Responded">{{ '-' }}</label>
      </div>
    </div>
    <div class="row"></div>
  </div>
  <div class="audio-container">

    <div class="voicemail-content">
  
      <!-- Audio Section -->
      <div class="voicemail-audio-section">
        <div class="section-title">Audio</div>
  
        <div class="audio-content">
          <div *ngIf="isRecordLoaded">
            <app-videojs-wavesurfer
              [recordingDetails]="recordingDetails">
            </app-videojs-wavesurfer>
          </div>
  
          <div
            class="audio-loading"
            *ngIf="!isRecordLoaded">
          </div>
        </div>
      </div>
  
  
      <!-- Transcript Section -->
      <div class="voicemail-transcript-section">
        <div class="section-title">Transcript</div>
  
        <div class="transcript-container">
          <div class="transcript-speaker">
            {{ transcriptSpeaker }}
            </div>
          <div class="transcript-text">
            {{ transcriptText }}
          </div>
        </div>
      </div>
  
    </div>
  
  
    <!-- KEEP EXISTING ACTION BUTTONS -->
    <div class="row action-container">
      <button
        class="btn- btn-outline-primary action-btn"
        (click)="replyToVoiceMail()">
        Reply
      </button>
  
      <button
        class="btn- btn-outline-primary action-btn"
        (click)="deleteVoicemail()">
        Delete
      </button>
    </div>
  
  </div>

  <!-- <div class="audio-container">
    <div class="row">
      <div *ngIf="isRecordLoaded">
        <app-videojs-wavesurfer [recordingDetails]="recordingDetails"></app-videojs-wavesurfer>
      </div>
      <div class="audio-loading" *ngIf="!isRecordLoaded"></div>
    </div>
    <div class="row action-container">
      <button class="btn- btn-outline-primary action-btn" (click)="replyToVoiceMail()">Reply</button>
      <button class="btn- btn-outline-primary action-btn" (click)="deleteVoicemail()">Delete</button>
    </div>
  </div> -->
</div>
